import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import RegisterPage from "./pages/RegisterPage";
import SponsorPage from "./pages/SponsorPage";
import GalleryPage from "./pages/GalleryPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminGallery from "./pages/AdminGallery";
import AdminHeroVideo from "./pages/AdminHeroVideo";
import AdminRegistrations from "./pages/AdminRegistrations";
import AdminSponsors from "./pages/AdminSponsors";
import AdminContacts from "./pages/AdminContacts";
import AdminSettings from "./pages/AdminSettings";
import AdminPartners from "./pages/AdminPartners";
import AdminEvents from "./pages/AdminEvents";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/register/:event" element={<RegisterPage />} />
          <Route path="/sponsor" element={<SponsorPage />} />
          <Route path="/gallery/:eventId" element={<GalleryPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="registrations" element={<AdminRegistrations />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="hero-video" element={<AdminHeroVideo />} />
            <Route path="sponsors" element={<AdminSponsors />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
